import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { useSelector } from 'react-redux';
import { getDefaultBreadcrumbs } from 'selectors';
import { useBreadcrumbs, useSelectorProps } from 'hooks';
import BreadCrumbs from 'components/BreadCrumbs';

function PageBreadCrumbs() {
  var selectorProps = useSelectorProps();
  var defaultBreadcrumbs = useSelector(function (state) {
    return getDefaultBreadcrumbs(state, selectorProps);
  });
  var breadcrumbs = useBreadcrumbs(defaultBreadcrumbs);
  return breadcrumbs.length ? /*#__PURE__*/_jsx(BreadCrumbs, {
    breadcrumbs: breadcrumbs
  }) : null;
}

export default PageBreadCrumbs;